import { QueryClient } from '@tanstack/react-query';

// Singleton instance to access queryClient outside of React components
let queryClientInstance: QueryClient | null = null;

export const setQueryClient = (client: QueryClient) => {
  queryClientInstance = client;
};

export const getQueryClient = (): QueryClient => {
  if (!queryClientInstance) {
    throw new Error(
      'QueryClient has not been initialized. Make sure QueryClientProvider is set up.',
    );
  }
  return queryClientInstance;
};
